import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { BackButton } from '@/components/atoms/BackButton';
import { Copy } from '@/components/atoms/Copy';
import { formatReferencesWithRefsAtEnd } from '@/constants/referencing';
import { TextWithReferences } from '@/helpers/formatReferences';
import { Fact } from '@/types';

interface FullSummaryViewProps {
  summaryText: string;
  onBack: () => void;
  keyFacts?: Fact[];
}

const FullSummaryView = ({ summaryText, onBack, keyFacts = [] }: FullSummaryViewProps) => {
  return (
    <div className="flex flex-col leading-relaxed">
      {/* Header */}
      <div className="mb-4 flex items-center justify-between border-b border-gray-100 pb-4">
        <div className="flex items-center gap-4">
          <BackButton onClick={onBack} />
          <h1 className="text-lg font-semibold text-gray-900">Case Summary</h1>
        </div>
        <Copy
          copyHandler={() => {
            trackCustomEvent(TrackingEvents.CopySummary);
            const formattedSummary = formatReferencesWithRefsAtEnd(summaryText, keyFacts);
            navigator.clipboard.writeText(formattedSummary);
          }}
        />
      </div>

      {/* Full Content */}
      <div className="rounded-lg bg-white p-6 shadow-sm">
        <div className="prose max-w-none text-sm leading-relaxed">
          <TextWithReferences content={summaryText} />
        </div>
      </div>
    </div>
  );
};

export default FullSummaryView;
